import { GvfNetworkError } from './errors/GvfNetworkError';
import { UserNotAuthorizedError } from './errors/UserNotAuthorizedError';
import { UnknownVehicleError } from './errors/UnknownVehicleError';
import { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';

interface ISpecification {
    readonly codeText: string,
    readonly origin: string
}

export interface IGvfResponse {
    readonly vin?: string;
    readonly modelName?: string;
    readonly exteriorColor?: string;
    readonly engine?: string;
    readonly specifications?: ISpecification[];
    readonly modelYear?: string;
}

export class GvfClient {

    private readonly resourceHostId: string;

    constructor(private readonly localeService: LocaleServiceV1, private readonly authService: IAuthServiceV2, stage: string) {
        this.resourceHostId = `myvw-gvf-proxy-${stage}`
    }

    public async getGvfData(vehicleId: string): Promise<IGvfResponse | undefined> {
        let response;
        try {
            const baseUrl = `vehicleData/${this.localeService.language}-${this.localeService.countryCode}`;
            response = await this.authService.get(this.resourceHostId, `${baseUrl}/${vehicleId}`);
        } catch (e: any) {
            if (e.message === 'Network Error' || e.code === 'ECONNABORTED') {
                throw new GvfNetworkError();
            }
        }

        if (!response) {
            throw new GvfNetworkError();
        }

        if (response.status === 401) {
            throw new UserNotAuthorizedError();
        } else if (response.status === 404) {
            throw new UnknownVehicleError();
        } else if (!response.ok) {
            throw new GvfNetworkError();
        }

        return await response.json() as IGvfResponse;
    }

    public async getGvfDetails(vehicleId: string): Promise<IGvfResponse | undefined> {
        try {
            const response = await this.authService.get(this.resourceHostId,
                `vehicleDetails/${this.localeService.language}-${this.localeService.countryCode}/${vehicleId}`);
            return await response.json() as IGvfResponse;
        } catch {
            return undefined;
        }
    }
}
